import { ScenarioInput } from '../types';

export const defaultScenario: ScenarioInput = {
  projectName: '华东综合 CCER 项目',
  sector: 'forestry',
  region: '项目区',
  areaHa: 1260,
  durationYears: 20,
  startYear: 2027,
  creditPrice: 68,
  discountRate: 0.08,
  capitalCost: 12800000,
  opexAnnual: 820000,
  bufferShare: 0.12,
  leakageRate: 0.06,
  permanenceRate: 0.92,
  rampUpYears: 3,
  degradationRate: 0.015,
  treeDensity: 1250,
  biomassIncrement: 4.8,
  soilSequestration: 1.4,
  yieldDelta: 0.18,
  residueFactor: 1.2,
  gridFactor: 0.58,
  energySavedMWh: 21000,
  systemEfficiency: 0.86,
  methaneAbatementTco2e: 18000,
  wastewaterLoad: 1.2,
  waterIndex: 0.55,
  wetlandAreaShare: 0.34,
};

export const sectorCatalog = [
  {
    id: 'forestry',
    label: '林业/造林',
    summary: '适合造林、抚育、森林经营、碳汇提升。',
    hint: '依赖面积、蓄积增量、土壤碳和永久性折减。',
  },
  {
    id: 'agriculture',
    label: '农业/土壤',
    summary: '适合保护性耕作、秸秆还田、低碳种植。',
    hint: '重点看产量变化、残体系数和土壤固碳。',
  },
  {
    id: 'renewables',
    label: '新能源',
    summary: '适合光伏、风电、余热余压和替代电力。',
    hint: '核心是替代电量与电网排放因子。',
  },
  {
    id: 'efficiency',
    label: '工业节能',
    summary: '适合高效设备替换、工艺节能、能管优化。',
    hint: '按节电量和系统效率折算减排。',
  },
  {
    id: 'waste',
    label: '废弃物/甲烷',
    summary: '适合填埋气收集、污水甲烷、资源化处理。',
    hint: '甲烷回收与氧化链条要分开估算。',
  },
  {
    id: 'wetlands',
    label: '湿地/蓝碳',
    summary: '适合湿地修复、潮滩恢复、滨海碳汇。',
    hint: '对遥感、水文和边界精度更敏感。',
  },
] as const;
